import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { panelPath } from '../config/paths';

/** Requires login. Finished onboarding + paid access go to the panel; unpaid users may still revisit steps. */
export default function OnboardingGate() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-[#1c1420] text-[#c9b8d1]">
        {t('common.loading')}
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (user.onboardingCompleted && user.hasActiveAccess) {
    return <Navigate to={panelPath('/')} replace />;
  }
  if (user.onboardingCompleted && !user.hasActiveAccess && location.pathname === '/onboarding') {
    return <Navigate to="/select-plan" replace />;
  }
  return <Outlet />;
}
